import Slider from "react-slick"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Image,Carousel } from "antd"
import api from "@/net/api"
import { btmImgSlice } from "@/store"

export default function SliderComponent(props) {
	const btmImg = useSelector(state => state.btmImg || null)
	let {config = {}} = props
	const settings = {
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		vertical: false,
		...config,
	}

	// const user = useSelector(state => state.sysuserInfo || {})
	const [list, setList] = useState([])
	async function getList() {
		let param = {
			currentPage: 1,
			pageSize: 10,
			location: "TOUCHSCREEN_DOWN",
			orgRegionId: user.orgRegionId,
		}
		try {
			let d = await api.config_banner_list(param)
			setList(d.list)
		} catch(e) {
			console.log(e)
		}
	}

	useEffect(() => {
		// getList()
	}, [])

	return <div style={{ marginLeft: "30px", marginRight: "30px", ...(props.style || {}) }}>
		{/* <Slider {...settings} className="components_sc_SliderComponent">
		{list.map((item, i) =>
			<Image
				className="img"
				key={i}
				width={1020}
				height={256}
				preview={false}
				src={btmImg}
			/>
		)}
		</Slider> */}
		<div className="components_sc_SliderComponent">
			<Carousel autoplay style={{width:'1440px'}}>
				{btmImg && btmImg.map((item,index)=><div className='goods-img cover' key={index}>
					<ImgOrVideoFooter item={item.url} />
				</div>)}
			</Carousel>
		</div>
	</div>

	function ImgOrVideoFooter({item}){
    let isVideo = item.includes('.mp4')||item.includes('.avi')||item.includes('.mov')||item.includes('.flv')
    let suffix = 'mp4'
    if(isVideo){
			if(item.includes('/NEWS/')){
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      }else{
        suffix = item.split('.com/')[1].split('.')[1]
      }
      // suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
    }
    
    return (
      isVideo ? <video className='img' style={{width:'1020px',height:'260px'}} autoPlay loop controls src={item} type={"video/"+suffix}></video>
      :
    <img className='img cover' style={{width:'1020px',height:'260px'}} mode="scaleToFill" src={item} />
    )
    
  }
}
